import {
  IAutoVariables,
  IAutoVariablesPayload,
  TCoverageKeys,
  TVehicleCoverageKey,
} from '@sureapp/platform-sdk';

export default function getFormattedCoverageVars(
  vars: IAutoVariablesPayload
): IAutoVariablesPayload {
  const {
    policy_variables: policyVariables,
    vehicle_variables: vehicleVariables,
  } = vars;

  const policyVars: Partial<IAutoVariablesPayload['policy_variables']> = {};
  const vehicleVars: Partial<IAutoVariablesPayload['vehicle_variables']> = {};

  Object.keys(policyVariables).forEach((key) => {
    const updatedVar = Object.assign(policyVariables[key as TCoverageKeys], {
      type: 'policy',
    });
    policyVars[key as TCoverageKeys] = updatedVar;
  });

  Object.keys(vehicleVariables).forEach((key) => {
    const updatedVar = Object.assign(
      vehicleVariables[key as TVehicleCoverageKey],
      {
        type: 'vehicle',
      }
    );
    vehicleVars[key as TVehicleCoverageKey] = updatedVar;
  });

  const updatedVars: IAutoVariablesPayload = {
    ...vars,
    variables: {
      ...policyVars,
      ...vehicleVars,
    } as IAutoVariables,
  };

  return updatedVars;
}
